import { render, staticRenderFns } from "./OnlineServe.vue?vue&type=template&id=67ff8f62&"
import script from "./OnlineServe.vue?vue&type=script&lang=js&"
export * from "./OnlineServe.vue?vue&type=script&lang=js&"
import style0 from "./OnlineServe.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports